(function() {
  if (window.innerWidth >= 768) return;

  var active = null;
  var startDist = 0;
  var currentScale = 1;
  var originX = 0;
  var originY = 0;
  var hiResLoaded = new WeakSet();

  function getDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getMid(t) {
    return {
      x: (t[0].clientX + t[1].clientX) / 2,
      y: (t[0].clientY + t[1].clientY) / 2
    };
  }

  function loadHiRes(container) {
    if (hiResLoaded.has(container)) return;
    var zoomSrc = container.getAttribute('data-zoom-src');
    if (!zoomSrc) return;
    var img = container.querySelector('img');
    if (!img) return;
    hiResLoaded.add(container);
    var hiRes = new Image();
    hiRes.onload = function() {
      img.src = zoomSrc;
      img.srcset = '';
    };
    hiRes.src = zoomSrc;
  }

  document.addEventListener('touchstart', function(e) {
    if (window.innerWidth >= 768) return;
    if (e.touches.length !== 2) return;

    var container = e.target.closest('.xo-product-info-media-mobile__image');
    if (!container) return;

    e.preventDefault();
    active = container;
    startDist = getDist(e.touches);
    currentScale = 1;

    var rect = container.getBoundingClientRect();
    var mid = getMid(e.touches);
    originX = mid.x - rect.left;
    originY = mid.y - rect.top;

    active.style.transformOrigin = originX + 'px ' + originY + 'px';
    active.style.transition = 'none';
    active.style.zIndex = '100';

    loadHiRes(container);

    var hint = document.getElementById('mobileZoomHint');
    if (hint) hint.classList.add('is-hidden');
  }, { passive: false });

  document.addEventListener('touchmove', function(e) {
    if (!active || e.touches.length !== 2) return;
    e.preventDefault();

    var dist = getDist(e.touches);
    currentScale = Math.max(1, Math.min(4, dist / startDist));

    active.style.transform = 'scale(' + currentScale + ')';
  }, { passive: false });

  document.addEventListener('touchend', reset, { passive: true });
  document.addEventListener('touchcancel', reset, { passive: true });

  function reset(e) {
    if (!active) return;
    if (e.touches && e.touches.length >= 2) return;

    active.style.transition = 'transform 0.25s ease';
    active.style.transform = 'scale(1)';
    var el = active;
    active = null;
    currentScale = 1;

    setTimeout(function() {
      el.style.transition = '';
      el.style.transform = '';
      el.style.transformOrigin = '';
      el.style.zIndex = '';
    }, 260);
  }
})();
